import {
  Component,
  Inject,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/state/app.state";
import * as GlobalSubheaderActions from "../../store/actions/global-subheader.actions";
import { PharmaDataService } from "../pharma-data.service";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { DOCUMENT } from "@angular/common";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
@Component({
  selector: "app-drug-page",
  templateUrl: "./drug-page.component.html",
  styleUrls: ["./drug-page.component.scss"],
  host: { class: "drug-page-component" },
})
export class DrugPageComponent implements OnInit {
  routeSubscriber: Subscription;
  dpCallSubscriber: Subscription;
  cTagId: number;
  isExportInProgress = false;
  //snackbar
  snackbarInfo: { message: string; type: string } = {
    message: "",
    type: "info",
  };
  snackBarRef: MatSnackBarRef<any>;
  snackbarMessage = "";
  private snackBar: MatSnackBar;

  @ViewChild("successTemplate") successTemplate: TemplateRef<any>;
  @ViewChild("failureTemplate") failureTemplate: TemplateRef<any>;
  @ViewChild("infoTemplate") infoTemplate: TemplateRef<any>;

  constructor(
    private store: Store<AppState>,
    private dataService: PharmaDataService,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private _document: HTMLDocument,
  ) {}
  tabNumber = 0;
  tabDetails = {
    "0": "Sales Analysis",
    "1": "Analyst Estimates",
  };

  auditFormulabarVisible = false;
  ngOnInit() {
    this.setSubheaderTitle();
    this.routeSubscriber = this.route.params.subscribe((param) => {
      try {
        if (param.cTagId) {
          this.cTagId = parseInt(param.cTagId);
        } else {
          console.error("Ctagid is mandatory in route param");
        }
      } catch (e) {
        console.error("Invalid ctagid ", e);
      }
    });

    this.dataService.dpClicked.subscribe(({ selectedCell, auditCols }) => {
      /*
         If it is undefined, it is a period data not Indications by phase
         Hence show subheader formula, else show audit fbar
        */
      if (!selectedCell) return;
      const colName = selectedCell.substring(selectedCell.indexOf("|") + 1);
      this.formulabarVisible(
        selectedCell && colName !== -1 && auditCols.indexOf(colName) !== -1,
      );
    });
  }

  setSubheaderTitle() {
    this.store.dispatch(
      new GlobalSubheaderActions.SubheaderTitleChanged({
        title: "BioPharma",
        sup: "",
        link: "",
      }),
    );
  }

  pharmaExportToExcel(params) {
    this.dataService.pharmaFullExportInProgress.next(true);
    this.dataService.getPharmaFullExportData(params).subscribe(
      (res) => {
        if (res["status"] === "success") {
          this.snackbarInfo.message = `${res["filename"]} export in progress.`;
          this.snackbarInfo.type = "info";
          const fileName = res["filename"];
          const trackerId = res["trackerid"];
          const downloadUrl = `/api/excel_file_download?exceltrackerid=${trackerId}`;
          const startIFrameTime = new Date().getTime();
          const iFrameToLoad = this._document.createElement("iframe");
          const body = this._document.getElementsByTagName("body")[0];
          iFrameToLoad.id = `${fileName}`;
          iFrameToLoad.name = `${fileName}`;
          iFrameToLoad.src = downloadUrl;
          iFrameToLoad.setAttribute("style", "visibility:hidden;display:none");
          body.appendChild(iFrameToLoad);

          const checkInterval = setInterval(() => {
            const iFrameToGet = this._document.getElementById(
              `${fileName}`,
            ) as HTMLIFrameElement;
            const iFrame =
              iFrameToGet.contentDocument || iFrameToGet.contentWindow.document;
            /*
        This check will run till the iFrame either doesn't load or for a max of 30secs
        Or till the ready state of the iFrame doesn't evaluate
      */
            if (
              iFrame.readyState === "complete" ||
              iFrame.readyState === "interactive" ||
              new Date().getTime() - startIFrameTime > 30000
            ) {
              clearInterval(checkInterval);
              this.dataService.pharmaFullExportInProgress.next(false);
              return;
            }
          }, 2000);
          // this.dataService.pharmaFullExportInProgress.next(false);
          // this.dataService.logUserAction("EXCEL_TRACKER", {
          //   templateType: res["template"]["templatetype"],
          //   export_type: res["export_as"],
          //   tracker_id: trackerId,
          //   file_name: fileName,
          // });
        } else {
          this.dataService.pharmaFullExportInProgress.next(false);
          this.snackbarInfo.message = `${res["filename"]} export couldn't be downloaded.`;
          this.snackbarInfo.type = "failure";
        }
      },
      (err) => {
        this.dataService.pharmaFullExportInProgress.next(false);
        console.error(err);
      },
    );
  }

  onTabChange(tabNumber) {
    this.tabNumber = tabNumber;
    this.store.dispatch(new GlobalSubheaderActions.DeleteDpParams());
    this.dataService.logUserAction(
      "DRUG_PAGE_TAB_SWITCH",
      {
        drugCtag: this.cTagId,
        tabName: this.tabDetails[tabNumber],
      },
      "BIOPHARMA_DRUG_PAGE",
    );
  }

  formulabarVisible(isVisible) {
    this.auditFormulabarVisible = isVisible;
  }
  ngOnDestroy() {
    if (this.routeSubscriber) {
      this.routeSubscriber.unsubscribe();
    }
    if (this.dpCallSubscriber) {
      this.dpCallSubscriber.unsubscribe();
    }
  }
}
